var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import LayerAPI from "./LayerAPI";
import { APIMessageType, LayerState } from "./Types";
function layerReducer(state, message) {
    switch (message.type) {
        case APIMessageType.PushLayer:
            return __spreadArrays(state, [
                {
                    key: message.key,
                    render: message.render,
                    state: LayerState.Active
                }
            ]);
        case APIMessageType.UpdateLayer:
            if (state.findIndex(function (layer) { return layer.key === message.key && layer.render !== message.render; }) === -1) {
                return state;
            }
            return state.map(function (layer) {
                return layer.key === message.key
                    ? __assign(__assign({}, layer), { render: message.render }) : layer;
            });
        case APIMessageType.TransitionExitLayer:
            if (state.findIndex(function (layer) { return layer.key === message.key; }) === -1) {
                return state;
            }
            return state.map(function (layer) {
                return layer.key === message.key
                    ? __assign(__assign({}, layer), { state: LayerState.TransitionExit }) : layer;
            });
        case APIMessageType.RemoveLayer:
            return state.filter(function (layer) { return layer.key !== message.key; });
    }
    return state;
}
// Memoize children to avoid infinite recursive rendering (Layer rendering Layer)
var RenderedLayer = React.memo(function (_a) {
    var layer = _a.layer;
    var completeTransitionExit = React.useCallback(function () { return LayerAPI.removeLayer(layer.key); }, [layer.key]);
    return (React.createElement(React.Fragment, null, layer.render({
        state: layer.state,
        completeTransitionExit: completeTransitionExit
    })));
});
var LayerContainer = React.memo(function (_a) {
    var _b = _a.context, context = _b === void 0 ? LayerAPI : _b;
    var _c = React.useReducer(layerReducer, []), layers = _c[0], dispatch = _c[1];
    React.useEffect(function () { return context.addListener(dispatch); }, []);
    return (React.createElement(React.Fragment, null, layers.map(function (layer) { return (React.createElement(RenderedLayer, { layer: layer, key: layer.key })); })));
});
export default LayerContainer;
